export const CHAT_DIALOG_SURFACE_CLASS_NAME =
  "[&.dialog-content]:w-[calc(100vw-2rem)] [&.dialog-content]:max-w-xl [&.dialog-content]:max-h-[calc(100dvh-2rem)] rounded-2xl border-slate-200 bg-white text-slate-900 shadow-xl sm:rounded-2xl";

export const CHAT_THREAD_DIALOG_CLASS_NAME =
  "[&.dialog-content]:w-[calc(100vw-2rem)] [&.dialog-content]:max-w-2xl [&.dialog-content]:max-h-[calc(100dvh-2rem)] [&.dialog-content]:overflow-hidden flex h-[85dvh] min-h-0 flex-col gap-0 rounded-2xl border-slate-200 bg-slate-50 p-0 text-slate-900 shadow-xl sm:rounded-2xl";

export const CHAT_ALERT_CONTENT_CLASS_NAME =
  "w-[calc(100vw-2rem)] max-w-md max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-2xl border-slate-200 bg-white p-5 text-slate-900 shadow-xl sm:rounded-2xl sm:p-6";

export const CHAT_DIALOG_HEADER_CLASS_NAME = "min-w-0 text-left";

export const CHAT_DIALOG_DESCRIPTION_CLASS_NAME =
  "text-sm leading-6 text-slate-600 [overflow-wrap:anywhere]";

export const CHAT_DIALOG_FOOTER_CLASS_NAME =
  "gap-2 sm:space-x-0 [&>button]:m-0 [&>button]:min-h-12";
